import React from "react";

const OrderTrackCard = ({
  orderStatus = "order-confirmed",
  trackingSteps = {},
  collectionData = {}
}) => {
  const allSteps = [
    {
      id: 1,
      status: "order-confirmed",
      label: "Order Confirmed",
      key: "order_confirmed"
    },
    {
      id: 2,
      status: "shipped",
      label: "Shipped",
      key: "shipped"
    },
    {
      id: 3,
      status: "out-of-delivery",
      label: "Out For Delivery",
      key: "out_for_delivery"
    },
    {
      id: 4,
      status: "delivery",
      label: "Delivered",
      key: "delivered"
    }
  ];

  const steps = allSteps.map((step) => ({
    ...step,
    date: trackingSteps[step.key] || null
  }));

  const formatDate = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    const options = { weekday: "short", day: "numeric", month: "short" };
    return date.toLocaleDateString("en-US", options);
  };
  const getStatusClass = () => {
    if (collectionData.status === "pending") {
      return "order-confirmed";
    }
    return orderStatus;
  };

  return (
    <>
      <ol
        className={`hidden sm:grid grid-cols-4 flex-1 desktop-order-track ${getStatusClass()}`}
      >
        <li className="flex flex-col items-center gap-3 relative order-track">
          <p className="m-0 text-sm text-center text-black font-medium">
            Order Confirmed
          </p>
          <div className="rounded w-6 h-6 rounded-full"></div>
          <p className="m-0 text-xs leading-6 text-center text-black font-normal">
            Wed, 1 lth Jan
          </p>
        </li>
        <li className="flex flex-col items-center gap-3 relative order-track">
          <p className="m-0 text-sm text-center text-black font-medium">
            Shipped
          </p>
          <div className="rounded w-6 h-6 rounded-full"></div>
          <p className="m-0 text-xs leading-6 text-center text-black font-normal">
            Wed, 1 lth Jan
          </p>
        </li>
        <li className="flex flex-col items-center gap-3 relative order-track">
          <p className="m-0 text-sm text-center text-black font-medium">
            Out For Delivery
          </p>
          <div className="rounded w-6 h-6 rounded-full"></div>
          <p className="m-0 text-xs leading-6 text-center text-black font-normal">
            Wed, 1 lth Jan
          </p>
        </li>
        <li className="flex flex-col items-center gap-3 relative order-track">
          <p className="m-0 text-sm text-center text-black font-medium">
            Delivered
          </p>
          <div className="rounded w-6 h-6 rounded-full"></div>
          <p className="m-0 text-xs leading-6 text-center text-black font-normal">
            Wed, 1 lth Jan
          </p>
        </li>
      </ol>
      <ol className={`sm:hidden mob-order-track-wrapper  ${orderStatus}`}>
        <li className="flex pb-6 gap-4 relative mob-order-track">
          <div className="rounded w-6 h-6 rounded-full"></div>
          <div className="flex flex-col gap-2 w-[calc(100%-2.5rem)]">
            <p className="m-0 text-sm text-black font-medium">
              Order Confirmed
            </p>
            <p className="m-0 text-xs leading-6 text-black font-normal">
              Wed, 1 lth Jan
            </p>
          </div>
        </li>
        <li className="flex pb-6 gap-4 relative mob-order-track">
          <div className="rounded w-6 h-6 rounded-full"></div>
          <div className="flex flex-col gap-2 w-[calc(100%-2.5rem)]">
            <p className="m-0 text-sm text-black font-medium">Shipped</p>
            <p className="m-0 text-xs leading-6 text-black font-normal">
              Wed, 1 lth Jan
            </p>
          </div>
        </li>
        <li className="flex pb-6 gap-4 relative mob-order-track">
          <div className="rounded w-6 h-6 rounded-full"></div>
          <div className="flex flex-col gap-2 w-[calc(100%-2.5rem)]">
            <p className="m-0 text-sm text-black font-medium">
              Out For Delivered
            </p>
            <p className="m-0 text-xs leading-6 text-black font-normal">
              Wed, 1 lth Jan
            </p>
          </div>
        </li>
        <li className="flex pb-6 gap-4 relative mob-order-track">
          <div className="rounded w-6 h-6 rounded-full"></div>
          <div className="flex flex-col gap-2 w-[calc(100%-2.5rem)]">
            <p className="m-0 text-sm text-black font-medium">Delivered</p>
            <p className="m-0 text-xs leading-6 text-black font-normal">
              Wed, 1 lth Jan
            </p>
          </div>
        </li>
      </ol>
    </>
  );
};

export default OrderTrackCard;
